<script>
	import { fade } from 'svelte/transition'
</script>

<div class="wrapper" transition:fade>
	<h1>Loading analysis...</h1>
	<div class="loader" role="status" aria-label="Loading"></div>
</div>

<style>
	.wrapper {
		position: absolute;
		inset: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: var(--space-10);
		font-family: var(--font-body);
	}

	h1 {
		margin: 0;
		font-family: var(--font-display);
		font-size: var(--text-xl);
		font-weight: var(--weight-regular);
		letter-spacing: var(--track-none);
		color: var(--cream);
	}

	/* One hairline ring with a single rose arc. The 1.3s is ambient, so it
	   stays a literal; global.css stills it under prefers-reduced-motion. */
	.loader {
		width: var(--space-10);
		height: var(--space-10);
		border: 1px solid var(--border-strong);
		border-top-color: var(--rose);
		border-radius: var(--radius-circle);
		animation: spin 1.3s linear infinite;
	}

	@keyframes spin {
		to { transform: rotate(360deg); }
	}
</style>
